import mxGraphFactory from "mxgraph";
import { ADMIN_ASSET_URL } from '../constants';
import { COLOUR_MAPPINGS } from '../components/graph/elements/elementStyles';

const { mxConstants, mxPerimeter } = new mxGraphFactory();

const documentStyles = getComputedStyle(document.documentElement);
const defaultFont = documentStyles.getPropertyValue('--default-font-family');

export const BaseStyle = {
    name: 'base',
    size: {
        width: 120,
        height: 60,
    },
    style: {
        shape: mxConstants.SHAPE_LABEL,
        rounded: true,
        perimeter: mxPerimeter.ReactanglePerimeter,
        resizable: 0,
        overflow: 'hidden',
        whiteSpace: 'wrap',
        align: mxConstants.ALIGN_CENTER,
        verticalAlign: mxConstants.ALIGN_MIDDLE,
        fontFamily: defaultFont,
        fontSize: '14',
        fontColor: '#FFFFFF',
        fillColor: '#FDFDFD',
        strokeColor: '#999999',
        spacingLeft: 27,
        spacingRight: 10,
        portimage: `${ADMIN_ASSET_URL}/img/outcome.png`,
        imageWidth: 15,
        imageHeight: 15,
    },
};

export const ElementStyle = [
    {
        name: 'dragImage',
        hasBaseStyle: true,
        size: BaseStyle.size,
        style: {
            width: '120px',
            height: '60px',
            borderRadius: '10px',
            listStyleType: 'none',
            fontColor: 'white',
            fillColor: 'white',
        },
    },
    {
        name: 'outcome',
        hasBaseStyle: false,
        style: {
            edgeStyle: 'elbowEdgeStyle',
            shape: 'connector',
            labelBackgroundColor: '#FDFDFD',
            strokeWidth: '2',
            fontFamily: defaultFont,
            rounded: true,
        },
    },
    {
        name: 'start',
        hasBaseStyle: true,
        size: {
            width: 60,
            height: 60,
        },
        style: {
            shape: mxConstants.SHAPE_DOUBLE_ELLIPSE,
            perimeter: mxPerimeter.EllipsePerimeter,
            align: mxConstants.ALIGN_CENTER,
            fillColor: '#34b59d',
            strokeColor: '#34b59d',
            spacingLeft: 4,
            spacingRight: 4,
        },
    },
    {
        name: 'step',
        hasBaseStyle: true,
        size: BaseStyle.size,
        style: {
            imageWidth: '18',
            imageHeight: '18',
            image: `${ADMIN_ASSET_URL}/img/glyphicons/step.svg`,
            fillColor: '#62b7ed',
            strokeColor: '#62b7ed',
        },
    },
    {
        name: 'input',
        hasBaseStyle: true,
        size: BaseStyle.size,
        style: {
            imageWidth: '18',
            imageHeight: '18',
            image: `${ADMIN_ASSET_URL}/img/glyphicons/page.svg`,
            fillColor: '#67a5e7',
            strokeColor: '#67a5e7',
        },
    },
    {
        name: 'decision',
        hasBaseStyle: true,
        size: BaseStyle.size,
        style: {
            imageWidth: '18',
            imageHeight: '18',
            image: `${ADMIN_ASSET_URL}/img/glyphicons/decision.svg`,
            fillColor: '#7ccf60',
            strokeColor: '#7ccf60',
        },
    },
    {
        name: 'operator',
        hasBaseStyle: true,
        size: BaseStyle.size,
        style: {
            imageWidth: '18',
            imageHeight: '18',
            image: `${ADMIN_ASSET_URL}/img/glyphicons/operator.svg`,
            fillColor: '#5fcc64',
            strokeColor: '#5fcc64',
        },
    },
    {
        name: 'message',
        hasBaseStyle: true,
        size: BaseStyle.size,
        style: {
            imageWidth: '18',
            imageHeight: '14',
            image: `${ADMIN_ASSET_URL}/img/glyphicons/message.svg`,
            fillColor: '#54c473',
            strokeColor: '#54c473',
        },
    },
    {
        name: 'database_load',
        hasBaseStyle: true,
        size: BaseStyle.size,
        style: {
            imageWidth: '18',
            imageHeight: '18',
            image: `${ADMIN_ASSET_URL}/img/glyphicons/load.svg`,
            fillColor: '#f87d76',
            strokeColor: '#f87d76',
        },
    },
    {
        name: 'database_save',
        hasBaseStyle: true,
        size: BaseStyle.size,
        style: {
            imageWidth: '18',
            imageHeight: '18',
            image: `${ADMIN_ASSET_URL}/img/glyphicons/save.svg`,
            fillColor: '#eb687f',
            strokeColor: '#eb687f',
        },
    },
    {
        name: 'database_delete',
        hasBaseStyle: true,
        size: BaseStyle.size,
        style: {
            imageWidth: '18',
            imageHeight: '18',
            image: `${ADMIN_ASSET_URL}/img/glyphicons/delete.svg`,
            fillColor: '#d95879',
            strokeColor: '#d95879',
        },
    },
    {
        name: 'swimlane',
        hasBaseStyle: false,
        size: {
            width: 500,
            height: 150,
        },
        style: {

            shape: mxConstants.SHAPE_SWIMLANE,
            shadow: 0,
            horizontal: 0,
            align: 'center',
            verticalAlign: 'top',
            startSize: 30,
            resizable: 1,
            rounded: false,
            fillColor: '#f49756',
            strokeColor: '#f49756',
            fontFamily: defaultFont,
            fontSize: '12',
            fontColor: '#FFFFFF',
        },
    },
    {
        name: 'subflow',
        hasBaseStyle: true,
        size: BaseStyle.size,
        style: {
            image: `${ADMIN_ASSET_URL}/img/glyphicons/caret-down.svg`,
            imageWidth: '18',
            imageHeight: '18',
            fillColor: '#607D8B',
            strokeColor: '#607D8B',
        },
    },
    {
        name: 'return',
        hasBaseStyle: true,
        size: BaseStyle.size,
        style: {
            image: `${ADMIN_ASSET_URL}/img/glyphicons/caret-up.svg`,
            imageWidth: '18',
            imageHeight: '18',
            fillColor: '#9E9E9E',
            strokeColor: '#9E9E9E',
        },
    },
    {
        name: 'group',
        hasBaseStyle: false,
        size: {
            width: 500,
            height: 150,
        },
        style: {

            shape: mxConstants.SHAPE_SWIMLANE,
            shadow: 0,
            horizontal: 1,
            align: 'center',
            verticalAlign: 'top',
            startSize: 30,
            resizable: 1,
            rounded: true,
            fillColor: COLOUR_MAPPINGS.group,
            strokeColor: COLOUR_MAPPINGS.group,
            fontFamily: defaultFont,
            fontSize: '16',
            fontColor: '#FFFFFF',
        },
    },
];
